module.exports = __webpack_public_path__ + "img/user.65347c51.png";